export default "__VITE_ASSET__Cx00D1Ee__"